import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import moment from 'moment'

import { connect } from 'react-redux'
import { Modal, Select, Button } from 'advenio-components'
import { Form } from 'formsy-react'
import { Selectors as ClassroomSelectors } from '../../../Data/Redux/ClassroomRedux'
import BalanceActions from '../../../Data/Redux/BalanceRedux'

const InputsRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`
const InputContainer = styled.div`
  max-width: calc(100% - 30px);
`
const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0;
`

class LinkChargeModal extends Component {
  state = {
    isInvalid: true,
    receiptsOptions: [],
  }

  componentWillReceiveProps(nextProps) {
    this.updateReceipts(nextProps, this.props)
  }

  updateReceipts = (nextProps, currentProps) => {
    const areReceipts = nextProps.receipts.length !== currentProps.receipts.length
    if (areReceipts) {
      const receiptsOptions = nextProps.receipts.map(({ id, created_at, total_formatted }) => ({
        id,
        value: id,
        label: `${moment(created_at).format('YYYY MMM DD')} - ${total_formatted}`,
      }))
      const isInvalid = receiptsOptions.length <= 0
      this.setState({ receiptsOptions, isInvalid })
    }
  }

  handleSubmit = ({ receiptId }) => {
    const { chargeId } = this.props
    this.props.linkChargeToReceipt(chargeId, receiptId)
  }

  render() {
    const { open, onClose, sending } = this.props
    const { receiptsOptions } = this.state

    return (
      <Modal
        isOpened={open}
        onClose={onClose}
        headerTitle={'Vincular recibo'}
        statePath="balance"
        actionType="discount"
        typePrefix="BALANCE"
      >
        <Form onSubmit={this.handleSubmit}>
          <InputsRow>
            <InputContainer isOpen>
              <Select
                name="receiptId"
                label="Recibos"
                onChangeCallback={this.handleFormChange}
                options={receiptsOptions}
              />
            </InputContainer>
          </InputsRow>
          <ButtonsRow>
            <Button
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              primary
              type="submit"
              loading={sending}
              disabled={this.state.isInvalid}
            >
              Agregar
            </Button>
          </ButtonsRow>
        </Form>
      </Modal>
    )
  }
}

LinkChargeModal.propTypes = {
  /** The ID of the parent charge */
  chargeId: PropTypes.number,
  /** The currency being used. Includes the currency code (e.g. MXN) and symbol (e.g. $) */
  /** Callback function when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Flag marking if the modal should be open */
  open: PropTypes.bool.isRequired,
  /** Flag marking if the discount is in the process of being sent to the API */
  sending: PropTypes.bool.isRequired,
  linkChargeToReceipt: PropTypes.func,
}

LinkChargeModal.defaultProps = {
  chargeId: null,
  currency: {},
  discount: {},
  editMode: false,
  total: null,
  totals_before_retention: {},
  linkChargeToReceipt: () => {},
}


const mapStateToProps = state => ({
  student: ClassroomSelectors.activeStudent(state),
})

const mapDispatchToProps = dispatch => ({
  linkChargeToReceipt: (chargeId, receiptId) => dispatch(
    BalanceActions.linkChargeToReceiptRequest(chargeId, receiptId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LinkChargeModal)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/LinkChargeModal.jsx